export function filterOutArchived<T extends { deleted_at: number | null}>(items: T[]): T[] {
    return items.filter(item => !item.deleted_at);
}